module.exports = __webpack_public_path__ + "static/media/match-notify.210749f1.svg";